<template>
  <div class="setting-user-two-factor">
    <confirm-dialog ref="confirmDialog"></confirm-dialog>
    <setting-user-two-factor-dialog ref="settingUserTwoFactorDialog"></setting-user-two-factor-dialog>
    <div class="card">
      <div class="caption">2段階認証</div>
      <div class="content">
        <div>
          <div class="basic">2段階認証を有効化すると、ログイン後に1回限りの認証コードの入力が必要になります。</div>
          <div class="basic">
            何者かがパスワードを不正に入手したとしてもアカウントにログインできないため、セキュリティが強化されます。
          </div>
        </div>
      </div>
      <div class="action" layout layout-align="end-center">
        <el-button v-if="!user.isTwoFactor" type="primary" @click="openTwoFactorDialog">2段階認証を有効化</el-button>
        <el-button v-else type="primary" :disabled="is_submit" @click="removeTwoFactor">2段階認証を解除</el-button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.card {
  margin-bottom: $spacing-unit * 2;

  .caption {
    margin-bottom: $spacing-unit * 2;
  }

  .content {
    .basic {
      margin-bottom: $spacing-unit * 0.5;
    }
  }
}
</style>
<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import ConfirmDialog from '@/client/components/_atoms/confirm_dialog'
import api from '@/client/core/api'
import SettingUserTwoFactorDialog from '@/client/features/setting_user/setting_user_two_factor_dialog'
import { TrackingService } from '@/client/services'
import { useSystemStore } from '@/client/store/useSystemStore'

export default defineComponent({
  components: {
    ConfirmDialog,
    SettingUserTwoFactorDialog
  },
  data() {
    return {
      is_submit: false
    }
  },
  computed: {
    ...mapState(useSystemStore, {
      user: state => state.user
    })
  },
  methods: {
    ...mapActions(useSystemStore, {
      setSystemUser: 'setUser'
    }),

    /**
     * 2段階ユーザー設定ダイアログを開く
     */
    openTwoFactorDialog() {
      TrackingService.sendEvent('click:ユーザー設定|2段階認証を有効化')

      this.$refs.settingUserTwoFactorDialog.open()
    },

    /**
     * 2段階認証を解除する
     */
    removeTwoFactor() {
      if (this.is_submit) {
        return
      }

      this.$refs.confirmDialog.open('2段階認証を解除してよろしいですか？', '', 'default', async confirm => {
        if (!confirm) {
          return
        }

        this.is_submit = true

        // ユーザー設定を変更
        const result = await api.delete('v1/two_factor')

        this.is_submit = false

        if (result && result.data) {
          // システムユーザーストアに変更
          const user = { ...this.user, isTwoFactor: 0 }

          this.setSystemUser(user)

          this.$notify({
            title: '2段階認証を解除しました。',
            customClass: 'success',
            duration: 5000
          })

          return
        }

        // エラーメッセージを表示
        this.$notify({
          title: '2段階認証の解除に失敗しました。',
          customClass: 'danger',
          duration: 5000
        })
      })
    }
  }
})
</script>
